/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
	function getWindowWidth() {
		return (
			window.innerWidth ||
			document.documentElement.clientWidth ||
			document.body.clientWidth
		);
	}

	function isDesktop() {
		return getWindowWidth() >= window.theme.sizes.small;
	}

	let isDesktopSize = isDesktop();

	document.addEventListener('DOMContentLoaded', function () {
		const is_product_page = window.location.pathname.includes('/products/');
		if (is_product_page) {
			const currentColor = window.theme.custom.currentColor;
			const product_images = document.querySelectorAll('.product__slide');
			if (isDesktopSize) {
				hideAndShowByClass(product_images, currentColor, 'hide');
				handleVariantChange();
			}

			document.addEventListener('theme:resize:width', function () {
				isDesktopSize = isDesktop();
				if (isDesktopSize) {
					hideAndShowByClass(product_images, currentColor, 'hide');
					handleVariantChange();
				} else {
					product_images.forEach((item, index) => {
						item.classList.remove('hide');
					});
				}
			});
		}
	});

	// Assign variant color to product image
	const is_product_page = window.location.pathname.includes('/products/');
	if (is_product_page) {
		var currentColorClass = window.theme.custom.currentColor;
		var variant_image_grouping = document
			.querySelector('.product__slides')
			.getAttribute('data-variant-image-grouping');
		var variant_image_option_index = document
			.querySelector('.product__slides')
			.getAttribute('data-variant-image-grouping-option-index');

		if (variant_image_grouping && variant_image_option_index !== '') {
			var groupingOptionIndex = variant_image_option_index;
			var productData = JSON.parse(
				document.querySelector('[data-product-json]').innerHTML,
			);

			// build map of grouping options and featured media
			var optionNameMediaMap = {};
			productData.media.forEach((media, index) => {
				productData.variants.forEach((variant) => {
					if (variant.featured_media && variant.featured_media.id == media.id) {
						if (!optionNameMediaMap[variant.options[groupingOptionIndex]]) {
							optionNameMediaMap[variant.options[groupingOptionIndex]] =
								media.id;
						}
					}
				});
			});

			// set option name on each image, when the first media id is found then keep assigning that until it is changed
			var currentMediaOptionName = '';
			const galleryImages = document.querySelectorAll('.product__slide');
			galleryImages.forEach((item, index) => {
				for (var optionName in optionNameMediaMap) {
					if (
						item.getAttribute('data-image-id') == optionNameMediaMap[optionName]
					) {
						currentMediaOptionName = optionName;
					}
				}

				item.dataset.variantImageGroup = currentMediaOptionName;
				var formattedClassName = currentMediaOptionName
					.split(' ')
					.join('_')
					.replace('-', '_')
					.toLowerCase();
				item.classList.add(formattedClassName);
			});
		}
	}

	function hideAndShowByClass(items, currentColorClass, classToToggle) {
		if (currentColorClass != null) {
			let first_item_index = null;
			items.forEach((item, index) => {
				item.classList.add(classToToggle);
				if (item.classList.contains(currentColorClass)) {
					if (first_item_index == null || first_item_index > index) {
						first_item_index = index;
					}
					item.classList.remove(classToToggle);
				}
			});
			items[first_item_index].classList.add('product__slide--first');
		}
	}

	// Change window.currentColor when swatch__button is selected by taking hte value of its input
	function handleVariantChange() {
		const swatch_buttons = document.querySelectorAll(
			'.product__block .swatch__button',
		);
		const product_images = document.querySelectorAll('.product__slide');
		swatch_buttons.forEach((item, index) => {
			item.addEventListener('click', function () {
				const swatch_value = item
					.querySelector('input')
					.value.toLowerCase()
					.replace(' ', '_')
					.replace('-', '_');
				window.theme.custom.currentColor = swatch_value;
				hideAndShowByClass(product_images, swatch_value, 'hide');
			});
		});
	}

	// ^^ Keep your scripts inside this IIFE function call to
	// avoid leaking your variables into the global scope.
})();
